import fetchData from "./fetchData";

const completeShopifyConnect = async (connectionId, userId) => {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}xeo/v1/completeShopifyConnect`;
    await fetchData({
        url: apiUrl,
        method: 'POST',
        body: {
            connectionId,
            userId,
        }
    })
}

export default completeShopifyConnect;